import { themeObject } from 'lib';

export const paperWrapperStyles = {
    main: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mr: '32px',
    },
    headerBox: { display: 'flex', ml: 4, mt: 2, mb: 2 },
    icon: { fontSize: '24px' },
    childContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        px: 2,
        mx: 2,
    },
    customHeight: { height: { xl: '90%', lg: '80%' } },
    backArrowIconContainerStyles: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mr: '12px',
        cursor: 'pointer',
    },
    backArrowIconStyles: {
        color: themeObject.palette.primary[500],
    },
    chipContainerStyles: {
        display: 'flex',
        alignItems: 'center',
        ml: '17.5px',
    },
    headerBoxContainerStyles: {
        width: '60%',
    },
};
